import { useMediaQuery, useTheme } from '@material-ui/core';
import { SdmSpacer, SdmTextButton, SdmTypography } from 'components';
import React from 'react';
import { useIntl } from 'react-intl';
import { theme } from 'theme';
import { backHomeLink } from 'utils/constants';
import translations from 'utils/translations';

const TicketsPendingOrderPage = ({ locale }) => {
  // Hooks
  const intl = useIntl();
  const i18n = translations.Tickets(intl);
  const mediaTheme = useTheme();
  const isSmDown = useMediaQuery(mediaTheme.breakpoints.down('sm'));
  const renderHeader = () => (
    <div
      style={{
        width: isSmDown ? '90%' : '80%',
        margin: '0 auto',
        maxWidth: 1063,
      }}
    >
      <SdmTypography
        variant={isSmDown ? 'h1' : 'fourtyFont'}
        style={{
          width: '100%',
          color: theme.colors.primary.black,
        }}
      >
        {i18n.pendingOrder.title}
      </SdmTypography>
      <SdmTypography
        variant={isSmDown ? 'h5Regular' : 'h2Regular'}
        style={{
          marginTop: 16,
          marginBottom: 32,
          width: '100%',
          color: theme.colors.primary.black,
        }}
      >
        {i18n.pendingOrder.text}
      </SdmTypography>
      <SdmTextButton
        variant={'redFill'}
        text={i18n.success.button}
        textVariant={'h4Regular'}
        onClick={() => {
          const path = window.location.pathname;
          window.location.href = `${backHomeLink}/${locale}${
            path?.includes('app') ? '/app' : ''
          }/sdm-tickets/my-orders`;
        }}
        style={{
          width: 273,
          height: 50,
          marginLeft: 0,
        }}
      />
      <SdmSpacer height={30} />
    </div>
  );

  return (
    <div>
      <SdmSpacer height={isSmDown ? 40 : 80} />
      {renderHeader()}
    </div>
  );
};

export default TicketsPendingOrderPage;
